import { useState, FC, PropsWithChildren, useEffect } from "react";
import { EPDStyle, light, dark } from "../../core/styles";
import { useTheme } from "@shared/EDS/contexts/useTheme";
import { EPDStyleContext } from "./EPDStyleContext";

export const EPDStyleProvider: FC<PropsWithChildren> = ({ children }) => {
  const [style, setStyle] = useState<EPDStyle>(light);
  const { isLightTheme } = useTheme();

  useEffect(() => {
    setStyle(isLightTheme ? light : dark);
  }, [isLightTheme]);

  return <EPDStyleContext value={{ style }}>{children}</EPDStyleContext>;
};
